import React, { useState, Fragment } from 'react';
import { FormGroup, Input, Label, Button } from 'reactstrap';
import Switch from '@material-ui/core/Switch';
import { DELETE_TAG, UPDATE_TAG } from '../../mutation/mutation';

const updateTag = async (client, data) => {
  return client.mutate({
    mutation: UPDATE_TAG,
    variables: data,
  }).catch((err) => {
    console.log('catch', err);
    alert(err);
  });
};

const deleteTag = async (client, tagId) => {
  return client.mutate({
    mutation: DELETE_TAG,
    variables: {
      tagId,
    },
  }).catch((err) => {
    console.log('catch', err);
    alert(err);
  });
};

export default ({ apolloClient, tag, tag: { _id: tagId }, onDelete }) => {
  const [titleEn, setTitleEn] = useState(tag.titleEn);
  const [titleFr, setTitleFr] = useState(tag.titleFr);
  const [rank, setRank] = useState(tag.rank);
  const [isActive, setIsActive] = useState(tag.isActive);

  return (
    <Fragment>
      <h2>{titleFr} - {titleEn}</h2>
      <FormGroup>
        <Label>Titre anglais</Label>
        <Input
          onBlur={() => updateTag(apolloClient, { tagId, titleEn })}
          onChange={({ target: { value } }) => setTitleEn(value)}
          value={titleEn}
        />
      </FormGroup>
      <FormGroup>
        <Label>Titre français</Label>
        <Input
          onBlur={() => updateTag(apolloClient, { tagId, titleFr })}
          onChange={({ target: { value } }) => setTitleFr(value)}
          value={titleFr}
        />
      </FormGroup>
      <FormGroup>
        <Label>Rang</Label>
        <Input
          onBlur={() => updateTag(apolloClient, { tagId, rank: +rank })}
          onChange={({ target: { value } }) => setRank(value)}
          type="number"
          value={rank}
        />
      </FormGroup>
      <FormGroup>
        <Label>Actif ?</Label>
        <Switch
          checked={isActive}
          onChange={() => {
            setIsActive(!isActive); updateTag(apolloClient, { tagId, isActive: !isActive });
          }}
          color="primary"
        />
      </FormGroup>
      <Button color="danger" size="sm" outline style={{ float: 'right' }} onClick={async () => {
        if (window.confirm('Vous êtes sur le point de supprimer le tag et le supprimer de tous les gifs avec lesquels il est associé.')) {
          await deleteTag(apolloClient, tagId);
          onDelete();
        }
      }}>Supprimer</Button>
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/tags/tag.js